import { Channel, SimpleReactionsList, useChatContext } from 'stream-chat-react';

import { AdminPanel } from '../AdminPanel/AdminPanel';
import { ChannelInner } from './ChannelInner';
import { EmptyChannel } from '../EmptyChannel/EmptyChannel';
import { TeamMessageInput } from '../TeamMessageInput/TeamMessageInput';
import {TeamTypingIndicator} from '../TeamTypingIndicator/TeamTypingIndicator';
import { ThreadHeader } from '../TeamChannelHeader/ThreadHeader';
import { TeamMessage } from '../TeamMessage/TeamMessage';

import { GiphyInMessageFlagProvider } from '../../context/GiphyInMessageFlagContext';
import { useWorkspaceController } from '../../context/WorkspaceController';
import { Box, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const LoadingIndicator = () => null;

export const ChannelContainer = ({ popout = false }) => {
  const { channel } = useChatContext();
  const { activeWorkspace } = useWorkspaceController();

  if (activeWorkspace.match('Admin')) {
    return <AdminPanel/>;
  }

  if(!channel) {
    return (
      <Box
        sx={{
          textAlign: 'center',
          m: 4,
          width: '100%',
        }}
      >
        <InfoOutlined
          sx={{
            fontSize: 40,
            fontWeight: 300,
          }}
          color="secondary"
        />
        <Typography
          variant="subtitle1"
          align="center"
          component="div"
          color="secondary"
          sx={{
            mt: 2,
            fontWeight: 300,
          }}
        >
          Select a Channel
        </Typography>
      </Box>
    )
  }

  return (
    <div className='channel__container'>
      <Channel
        EmptyStateIndicator={EmptyChannel}
        LoadingIndicator={LoadingIndicator}
        Input={TeamMessageInput}
        Message={TeamMessage}
        ReactionsList={SimpleReactionsList}
        ThreadHeader={ThreadHeader}
        TypingIndicator={TeamTypingIndicator}
      >
        <GiphyInMessageFlagProvider>
          <ChannelInner popout={popout} />
        </GiphyInMessageFlagProvider>
      </Channel>
    </div>
  );
};
